import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import CommonReportFilter from "./CommonReportFilter";
import moment from "moment";
import { Paginator } from 'primereact/paginator';
import * as jobConstants from "../../enums/jobs";
// import { useDispatch } from 'react-redux';
import {
    setExpandedReportDetailRows,
    fetchDetailsReportData,
    fetchDetailsDownloadReportData,
    fetchReportDetailsChildJobs,
    setPage,
    setSize,
    setBasicFirst,
    setBasicRows,
    setFilterDetailsKeyword,
} from "./reportSlice";
const DetailsReport = () => {
    const [rowsPerPageOptions, setRowsPerPageOptions] = useState(jobConstants.ROWS_PER_PAGE_OPTIONS);
    const jobState = useSelector((state) => state.job);
    const {
        userId,
        clientId,
        appLanguage,
    } = jobState;
    const protrackReports = useSelector((state) => state.reports);
    const {
        expandedReportDetailRows,
        detailsReportList,
        childJobDeailList,
        detailsDownloadReportList,
        reportStartDate,
        reportEndDate,
        filterChannelType,
        filterDocType,
        filterReportType,
        tabViewType,
        totalRecords,
        page,
        size,
        basicFirst,
        basicRows,
        filterDetailsKeyword,
    } = protrackReports;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [date, setDate] = useState(null);


    const rowExpansionTemplate = () => {
        return (
            <>
                <div className="summary-container">
                    <div className="summary-section-left">
                        <div className="summary-card child-summary-card">
                            <p><strong>{appLanguage["childjob.label.parent-filename"]} : </strong><span className="details-value-color" style={{ display: 'inline' }} title={childJobDeailList[0]?.parentFileName}>{childJobDeailList[0]?.parentFileName.length > 30 ? childJobDeailList[0]?.parentFileName.substring(0, 30) + "..." : childJobDeailList[0]?.parentFileName}</span></p>
                            <p><strong>{appLanguage["report.details.label.jobid"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.jobidentifier}</span></p>
                            <p><strong>{appLanguage["childjob.label.local-job-id"]} :</strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.JobNo}</span></p>
                            <p><strong>{appLanguage["details-childjob.label.no-of-child-files"]} :</strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.childfilenames[0]?.noofchildfiles}</span></p>
                            <p><strong>{appLanguage["details-childjob.label.child-filesnames"]} : </strong></p>
                            <ul className="file-list">
                                {childJobDeailList[0]?.childfilenames[0]?.childfilenames.split(", ").map((file, index) => (
                                    <li key={index}>{file}</li>
                                ))}
                            </ul>
                            {/* <li key={index}>{file}</li> */}
                        </div>
                    </div>

                    <div className="summary-container">
                        <div className="summary-section-center">
                            <div className="summary-card">
                                <p><strong>{appLanguage["details-childjob.label.no-of-records"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.noofrecords}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.no-of-enclosures"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.NoofEnclosures}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.no-of-documents"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.noofDocuments}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.no-of-images"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.noofImages}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.delivery-channel"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.deliverychannel}</span></p>
                                <p><strong>{appLanguage["childjob.label.received"]}:</strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.Receivedat ? moment(childJobDeailList[0]?.Receivedat).format("DD MMM YYYY-HH:mm") : "/"}</span></p>
                                {/* <p><strong>Processed : </strong> <span className="details-value-color">{moment(childJobDeailList[0]?.ChildCompelete).format("DD MMM YYYY")}</span></p> */}
                                <p><strong>{appLanguage["childjob.label.completed"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.Completedat ? moment(childJobDeailList[0]?.Completedat).format("DD MMM YYYY-HH:mm") : "/"}</span></p>
                            </div>
                        </div>

                        <div className="summary-section-right">
                            <div className="summary-card">
                                <p><strong>{appLanguage["details-childjob.label.c5-enclosures"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.C5Enclosures}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.c4-enclosures"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.C4Enclosures}</span></p>
                                <p><strong>{appLanguage["details-childjob.label.other-enclosures"]} : </strong> <span className="details-value-color" style={{ display: 'inline' }}>{childJobDeailList[0]?.OtherEnclosures}</span></p>
                                {/* <p><strong>Inserts : </strong></p>
                                <p style={{ marginLeft: '20px' }}><strong>Know Your Rights 2023 : </strong> <span className="details-value-color">{data.documents}</span></p>
                                <p style={{ marginLeft: '20px' }}><strong>Return Envelope C1782 : </strong> <span className="details-value-color">{data.documents}</span></p>
                                <p style={{ marginLeft: '20px' }}><strong>Right to Cancel A12023 : </strong> <span className="details-value-color">{data.documents}</span></p> */}

                                {childJobDeailList[0]?.Inserts?.length ? (
                                    <>
                                        <p><strong>Inserts :</strong></p>
                                        {childJobDeailList[0].Inserts.map((insert, index) => (
                                            <p key={index} style={{ marginLeft: '20px' }}>
                                                <strong>{insert.insertcode} :</strong>{" "}
                                                <span className="details-value-color" style={{ display: 'inline' }}>
                                                    {insert.cntInserts}
                                                </span>
                                            </p>
                                        ))}
                                    </>
                                ) : (
                                    <p><strong>Inserts : 0</strong></p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const allowExpansion = (e) => {
        return childJobDeailList.length > 0;
    };

    const expenderRow = (rowData) => {
        const parentJobNo = rowData.jobidentifier;
        let params = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join("|"),
            filterType: filterDocType,
            fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : moment(new Date(new Date().setFullYear(new Date().getFullYear() - 1))).format("YYYY-MM-DD"),
            toDate: reportEndDate ? moment(reportEndDate).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            reportType: filterReportType,
            JobIdentifier: parentJobNo,
        };

        const clickEvent = () => {
            let _expandedReportDetailRows = {};
            if (expandedReportDetailRows) {
                if (expandedReportDetailRows[`${rowData.jobidentifier}`]) {
                    const newDataObject = { ...expandedReportDetailRows };
                    delete newDataObject[`${rowData.jobidentifier}`];
                    dispatch(setExpandedReportDetailRows(newDataObject));
                } else {
                    dispatch(fetchReportDetailsChildJobs(params));
                    _expandedReportDetailRows[`${rowData.jobidentifier}`] = true;
                }
            } else {
                dispatch(fetchReportDetailsChildJobs(params));
                _expandedReportDetailRows[`${rowData.jobidentifier}`] = true;
            }
            dispatch(setExpandedReportDetailRows(_expandedReportDetailRows));
        }

        return (
            <>
                <a href='javascript:void(0)' onClick={clickEvent}><i className={'pi pi-' + (expandedReportDetailRows && expandedReportDetailRows[`${rowData.jobidentifier}`] == true ? 'minus' : 'plus')}></i></a>
            </>
        )

        // return (
        //     <>
        //         <a href="javascript:void(0)">
        //             <i className="pi pi-plus"></i>
        //         </a>
        //     </>
        // );
    };

    // Details serch icon
    const detailsSearchIcon = () => {
        return (
            <span className="details-search-icon">
                <i className="pi pi-search"></i>
            </span>
        );
    };

    // for channel file icon
    // const channelFile = () => {
    //     return (
    //         <span className="channel-file">
    //             <i className="pi ds-file-icon"></i>
    //         </span>
    //     );
    // };

    const channelFile = (rowData) => {
        const channelArray = rowData?.channelType?.split(',');
        return (
            channelArray?.length > 1 ? (
                <>
                    <span className='channel-file recycle-icon'>
                        <i className="ds-icon recycle-icon">
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px" y="0px"
                                viewBox="0 0 122.88 113.02"
                                width="20.731"
                                height="20"
                                style={{ marginTop: '4px' }}
                            >
                                <g>
                                    <path fill="#bfbfbf" d="M52.75,68.37c-7.63-6.3-17.48-9.41-29.54-9.35V44.02L0,67.81L23.21,90.9V77.76c9.07-0.05,15.78,2.48,20.14,7.61 c4.87,5.73,7.53,14.94,7.96,27.66l10.11-0.32l10.11,0.32c0.01-0.2,0.01-0.4,0.02-0.6h0.01v-0.35c0.53-12.23,3.17-21.12,7.92-26.71 c4.37-5.14,11.1-7.67,20.19-7.61V90.9l23.21-23.09L99.67,44.02v14.99c-11.32-0.06-20.69,2.66-28.11,8.19v-44h14.03L61.81,0 L38.72,23.21h14.03V68.37L52.75,68.37z" />
                                </g>
                            </svg>
                            {/* <svg
                id="noun-recycle-409903"
                xmlns="http://www.w3.org/2000/svg"
                width="24.731"
                height="25"
                viewBox="0 0 24.731 25"
              >
                <g id="Group_32" data-name="Group 32" transform="translate(0)">
                  <g id="Group_31" data-name="Group 31">
                    <path
                      id="Path_23"
                      data-name="Path 23"
                      d="M7.527,25.487a12.012,12.012,0,0,0,16.982-.006l-.809-.809a10.868,10.868,0,0,1-15.364.006l.411-.411c.446-.446.311-.933-.3-1.086l-2.092-.523c-.616-.154-.987.22-.833.833l.523,2.092c.154.616.64.749,1.086.3l.4-.4Zm20.1-5.41a12.012,12.012,0,0,0-8.5-14.692l-.3,1.105a10.868,10.868,0,0,1,7.69,13.291l-.553-.148c-.61-.163-.963.2-.789.805l.593,2.073a.63.63,0,0,0,1.138.3l1.55-1.5c.457-.441.329-.929-.281-1.092l-.554-.148ZM12.874,5.394A12.012,12.012,0,0,0,4.412,20.1l1.105-.3A10.868,10.868,0,0,1,13.17,6.5l.147.547c.163.61.652.735,1.092.281l1.5-1.55a.63.63,0,0,0-.3-1.138L13.53,4.045c-.611-.175-.969.179-.805.789l.15.56Z"
                      transform="translate(-4 -4)"
                      fill="#bfbfbf"
                      fill-rule="evenodd"
                    />
                  </g>
                </g>
              </svg> */}
                        </i>
                    </span>
                </>
            ) : channelArray?.includes('email') || channelArray?.includes('emailattach') ? (
                <>
                    <span className='channel-file email-icon'><i className="ds-icon email-icon">
                        <svg
                            id="noun-email-1002247"
                            xmlns="http://www.w3.org/2000/svg"
                            // width="24.602"
                            // height="25"
                            viewBox="0 0 24.602 25"
                            width="16.731"
                            height="20"
                            style={{ marginTop: '4px' }}
                        >
                            <path
                                id="Path_19"
                                data-name="Path 19"
                                d="M6.359,28.25H26.243A2.361,2.361,0,0,0,28.6,25.889V13.262a.669.669,0,0,0-.238-.511L25.072,9.97V5.122A1.872,1.872,0,0,0,23.2,3.25H9.533A1.872,1.872,0,0,0,7.661,5.122V9.868L4.238,12.751A.669.669,0,0,0,4,13.262V25.889A2.361,2.361,0,0,0,6.359,28.25ZM26.24,26.913H6.359a1.024,1.024,0,0,1-1.021-1.024V14.537l7.621,5.391-5.41,4.139a.669.669,0,1,0,.8,1.07l5.752-4.4,1.872,1.337a.669.669,0,0,0,.773,0l1.872-1.337,5.755,4.394a.669.669,0,0,0,.8-1.07l-5.4-4.131,7.487-5.295V25.891a1.024,1.024,0,0,1-1.021,1.021Zm.65-13.654-1.818,1.286V11.719ZM9.533,4.59H23.2a.535.535,0,0,1,.535.535V15.484L16.368,20.7,9,15.484V5.122A.535.535,0,0,1,9.533,4.59ZM7.661,14.545,5.768,13.208l1.893-1.6Zm8.64,2.722h.171a.669.669,0,0,0,0-1.337H16.3a4.262,4.262,0,1,1,4.262-4.262V12.81a.746.746,0,0,1-1.489,0V11.668A2.781,2.781,0,1,0,18,13.842a2.08,2.08,0,0,0,3.9-1.032V11.668a5.6,5.6,0,1,0-5.6,5.6Zm0-4.164a1.436,1.436,0,1,1,1.436-1.436A1.436,1.436,0,0,1,16.3,13.1Z"
                                transform="translate(-4 -3.25)"
                                fill="#bfbfbf"
                            />
                        </svg>
                    </i></span>
                </>
            ) : (
                <>
                    <span className='channel-file doc-icon'><i className="ds-icon doc-icon">
                        <svg
                            id="noun-document-5189726"
                            xmlns="http://www.w3.org/2000/svg"
                            // width="20"
                            // height="25.603"
                            viewBox="0 0 20 25.603"
                            width="16.731"
                            height="20"
                            style={{ marginTop: '4px' }}
                        >
                            <path
                                id="Path_5"
                                data-name="Path 5"
                                d="M32.716,8.471,26.923,2.679a.609.609,0,0,0-.431-.179H14.859a1.966,1.966,0,0,0-1.964,1.964V26.138A1.966,1.966,0,0,0,14.859,28.1H30.93a1.966,1.966,0,0,0,1.964-1.964V8.9A.609.609,0,0,0,32.716,8.471ZM27.1,4.581l3.711,3.711H27.847a.746.746,0,0,1-.745-.745V4.581Zm4.573,21.557a.746.746,0,0,1-.745.745H14.859a.746.746,0,0,1-.745-.745V4.464a.746.746,0,0,1,.745-.745H25.883V7.547a1.966,1.966,0,0,0,1.964,1.964h3.828Z"
                                transform="translate(-12.895 -2.5)"
                                fill="#bfbfbf"
                            />
                            <path
                                id="Path_6"
                                data-name="Path 6"
                                d="M26.537,24.269h6.09a.58.58,0,1,0,0-1.16h-6.09a.58.58,0,1,0,0,1.16Z"
                                transform="translate(-22.332 -17.541)"
                                fill="#bfbfbf"
                            />
                            <path
                                id="Path_7"
                                data-name="Path 7"
                                d="M25.957,40.109a.6.6,0,0,0,.626.58H38.631a.582.582,0,1,0,0-1.16H26.582A.6.6,0,0,0,25.957,40.109Z"
                                transform="translate(-22.607 -29.525)"
                                fill="#bfbfbf"
                            />
                            <path
                                id="Path_8"
                                data-name="Path 8"
                                d="M38.631,55.948H26.582a.582.582,0,1,0,0,1.16H38.631a.582.582,0,1,0,0-1.16Z"
                                transform="translate(-22.607 -41.509)"
                                fill="#bfbfbf"
                            />
                            <path
                                id="Path_9"
                                data-name="Path 9"
                                d="M38.631,72.368H26.582a.582.582,0,1,0,0,1.16H38.631a.582.582,0,1,0,0-1.16Z"
                                transform="translate(-22.607 -53.493)"
                                fill="#bfbfbf"
                            />
                        </svg>
                    </i></span>
                </>
            )
        );
    }

    const receivedDateBody = (rowData) => {
        return (
            <span>{rowData.jobstartdatetime ? moment(rowData.jobstartdatetime).format("DD MMM YY-HH:mm") : ''}</span>
        );
    }

    const completeDateBody = (rowData) => {
        return (
            <span>{rowData.jobenddatetime ? moment(rowData.jobenddatetime).format("DD MMM YY-HH:mm") : ''}</span>
        );
    }

    const downloadDetailsReport = () => {
        downloadCsv(detailsDownloadReportList, 'details_download_report.csv');
    }

    // Convert JSON to CSV
    const jsonToCsv = (jsonData) => {
        const isArray = Array.isArray(jsonData);
        if (isArray) {
            const headers = Object.keys(jsonData[0]);
            const csvRows = [];
            csvRows.push(headers.join(','));
            jsonData.forEach(item => {
                const values = headers.map(header => {
                    const value = item[header];
                    return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
                });
                csvRows.push(values.join(','));
            });
            return csvRows.join('\n');
        } else {
            const headers = Object.keys(jsonData);
            const values = headers.map(header => {
                const value = jsonData[header];
                return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
            });
            return `${headers.join(',')}\n${values.join(',')}`;
        }
    };

    // Trigger CSV download
    const downloadCsv = (jsonData, fileName) => {
        const csvData = jsonToCsv(jsonData);
        console.log('CSV Data:', csvData);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };

    /* For Paginator Template Start */
    const footer = (
        <React.Fragment>
            <Paginator
                className="pagination-wrap"
                first={basicFirst}
                rows={basicRows}
                totalRecords={totalRecords}
                onPageChange={(e) => onBasicPageChange(e)}
                rowsPerPageOptions={rowsPerPageOptions}
                template="CurrentPageReport PrevPageLink NextPageLink RowsPerPageDropdown"
                // currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                currentPageReportTemplate={`${appLanguage["datatable.label.pagination.showing"]} {first} ${appLanguage["datatable.label.pagination.to"]} {last} of {totalRecords}`}
            ></Paginator>
        </React.Fragment>
    );

    const onBasicPageChange = (e) => {
        const params = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join("|"),
            filterType: filterDocType,
            fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : moment(new Date(new Date().setFullYear(new Date().getFullYear() - 1))).format("YYYY-MM-DD"),
            toDate: reportEndDate ? moment(reportEndDate).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            reportType: 1,
            pageNum: e.page + 1,
            pageSize: e.rows,
            keyword: filterDetailsKeyword,
        }
        dispatch(fetchDetailsReportData(params));
        dispatch(setBasicFirst(e.first));
        dispatch(setBasicRows(e.rows));
        dispatch(setPage(e.page + 1));
        dispatch(setSize(e.rows));

    }
    /* For Paginator Template End */

    const rowClass = (rowData) => {
        return {
            'job-expended-row': rowData.jobidentifier == Object.keys(expandedReportDetailRows).join()
        }
    }

    const getReportDetailByIdentifier = (e) => {
        let filterParams = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join("|"),
            filterType: filterDocType,
            fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : '',
            toDate: e.value ? moment(e.value).format("YYYY-MM-DD") : '',
            reportType: 1,
            pageNum: page,
            pageSize: size,
        };
        if (e.key === 'Enter') {
            const keyword = e.target.value;
            console.log("Search keyword:", keyword);
            dispatch(setFilterDetailsKeyword(keyword));
            filterParams.keyword = e.target.value;
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
        }
    }

    const handleSearchChange = (e) => {
        const keyword = e.target.value;
        if (keyword.length > 2 || keyword.length === 0) {
            let filterParams = {
                clientId: clientId,
                userId: userId,
                typeId: tabViewType,
                channelType: filterChannelType.join("|"),
                filterType: filterDocType,
                fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : '',
                toDate: e.value ? moment(e.value).format("YYYY-MM-DD") : '',
                reportType: 1,
                pageNum: page,
                pageSize: size,
                keyword: keyword,
            };

            console.log("Search keyword:", keyword);
            dispatch(setFilterDetailsKeyword(keyword));

            // Trigger the report data fetch
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
        }
    };

    return (
        <div className="details-wrapper">
            <div className="two-col">
                <div className="left-col">
                    <CommonReportFilter />
                </div>
                <div className="right-col">
                    <div className="details-header-search-wrapper">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText
                                placeholder={appLanguage["report.details.placeholder.search"]}
                                onKeyDown={getReportDetailByIdentifier}
                                onChange={handleSearchChange}
                            />

                            {/* <InputText
                                value={filterDetailsKeyword}
                                placeholder={appLanguage["report.details.placeholder.search"]}
                                onKeyDown={getReportDetailByIdentifier}
                            /> */}

                        </span>
                        <span className="button-wrapper">
                            <button title="Download Source Data" onClick={downloadDetailsReport}>
                                <i className="download-icon"></i>
                            </button>
                            {/* <button>
                                <i
                                    className="zoom-icon"
                                 onClick={() => navigate("/commasla")}
                                ></i>
                            </button> */}
                        </span>
                    </div>
                    <DataTable value={detailsReportList} expandedRows={expandedReportDetailRows} onRowToggle={(e) => dispatch(setExpandedReportDetailRows(e.data))} rowExpansionTemplate={rowExpansionTemplate} dataKey="jobidentifier" tableStyle={{ minWidth: "50rem" }} footer={footer} rowClassName={rowClass} scrollable scrollHeight='380px' className='fixPaginationRepotDetail'>
                        <Column field="channel" header="" body={channelFile} style={{ width: "2rem" }}></Column>
                        <Column key="expander" expander={allowExpansion} field="expander" style={{ width: "2rem" }} body={expenderRow} />
                        <Column field="Businesstypename" header={appLanguage["report.details.label.name"]} style={{ width: "7rem" }}></Column>
                        <Column field="jobidentifier" header={appLanguage["report.details.label.jobid"]}></Column>
                        <Column field="applicationname" header={appLanguage["report.details.label.application"]}></Column>
                        <Column field="status" header={appLanguage["report.details.label.status"]}></Column>
                        <Column field="jobstartdatetime" header={appLanguage["report.details.label.received"]} body={receivedDateBody} style={{ width: "12rem" }}></Column>
                        <Column field="jobenddatetime" header={appLanguage["report.details.label.complete"]} body={completeDateBody} style={{ width: "12rem" }}></Column>
                        <Column field="SLA" header={appLanguage["report.details.label.sla"]} style={{ width: "5rem" }}></Column>
                        <Column field="" header="" body={detailsSearchIcon}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    )
}

export default DetailsReport;